if (!customElements.get('ah-reel')) {
  customElements.define('ah-reel', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const { signal } = this.abort;
      this.track = this.querySelector('.ah-reel-track');
      this.previous = this.querySelector('[data-reel-prev]');
      this.next = this.querySelector('[data-reel-next]');
      if (!this.track || !this.previous || !this.next) return;
      this.querySelector('.ah-reel-tools').hidden = false;
      this.previous.addEventListener('click', () => this.move(-1), { signal });
      this.next.addEventListener('click', () => this.move(1), { signal });
      this.track.addEventListener('scroll', () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      }, { passive: true, signal });
      this.addEventListener('play', event => {
        if (!(event.target instanceof HTMLVideoElement)) return;
        this.querySelectorAll('video').forEach(video => {
          if (video !== event.target) video.pause();
        });
      }, { capture: true, signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.querySelectorAll('video').forEach(video => video.pause());
      }, { signal });
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const card = event.target.closest('.ah-reel-card');
        if (card) card.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'nearest' });
      }, { signal });
      if ('ResizeObserver' in window) {
        this.resize = new ResizeObserver(() => this.update());
        this.resize.observe(this.track);
      }
      this.update();
    }
    move(direction) {
      const card = this.track.querySelector('.ah-reel-card');
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      this.track.scrollBy({
        left: direction * (rtl ? -1 : 1) * ((card?.getBoundingClientRect().width || this.track.clientWidth) + gap),
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
    }
    update() {
      const distance = Math.abs(this.track.scrollLeft);
      this.previous.disabled = distance < 2;
      this.next.disabled = distance >= this.track.scrollWidth - this.track.clientWidth - 2;
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.querySelectorAll('video').forEach(video => video.pause());
    }
  });
}
